import type { SportProfile } from '@/types'

export const softballSlowpitchCoed: SportProfile = {
  id: 'softball-slowpitch-coed',
  sport: 'softball',
  gender: 'coed',
  environment: 'outdoor',
  label: 'Coed Slowpitch Softball',
  emoji: '🥎',
  playersOnField: 10,
  contactLevel: 'limited',
  hasShotClock: false,
  hasBattingOrder: true,
  periods: { label: 'Inning', count: 7, durationMinutes: 20 },
  positions: [
    { key: 'pitcher',        label: 'Pitcher',        shortLabel: 'P'   },
    { key: 'catcher',        label: 'Catcher',         shortLabel: 'C'   },
    { key: 'first_base',     label: 'First Base',      shortLabel: '1B'  },
    { key: 'second_base',    label: 'Second Base',     shortLabel: '2B'  },
    { key: 'third_base',     label: 'Third Base',      shortLabel: '3B'  },
    { key: 'shortstop',      label: 'Shortstop',       shortLabel: 'SS'  },
    { key: 'left_field',     label: 'Left Field',      shortLabel: 'LF'  },
    { key: 'left_center',    label: 'Left Center',     shortLabel: 'LC'  },
    { key: 'right_center',   label: 'Right Center',    shortLabel: 'RC'  },
    { key: 'right_field',    label: 'Right Field',     shortLabel: 'RF'  },
  ],
  stats: [
    { key: 'hit',         label: 'Hit',                  shortLabel: 'H'   },
    { key: 'double',      label: 'Double',                shortLabel: '2B'  },
    { key: 'triple',      label: 'Triple',                shortLabel: '3B'  },
    { key: 'home_run',    label: 'Home Run',              shortLabel: 'HR'  },
    { key: 'rbi',         label: 'RBI',                   shortLabel: 'RBI' },
    { key: 'run',         label: 'Run Scored',            shortLabel: 'R'   },
    { key: 'walk',        label: 'Walk',                  shortLabel: 'BB'  },
    { key: 'strikeout',   label: 'Strikeout (batting)',   shortLabel: 'K'   },
    { key: 'error',       label: 'Error',                 shortLabel: 'E'   },
  ],
}
